export default __webpack_public_path__ + "static/media/0x6ddb31002abc64e1479fc439692f7ea061e78165.741d4062.webp";